module.exports = __webpack_public_path__ + "static/media/cover5.95f0a430.jpg";